import { transactionTypes, type TransactionType } from "./utils";

/**
 *
 */
export type SamplingEnvConfig = {
  "page-load": { [pagecluster: string]: number[] | undefined };
  "http-request": { [pagecluster: string]: number | undefined };
};

/*                                  */
/**
 *
 *
 */
const pageLoadLive = {
"AftersalesOrders":[	0.87,	1.00,	1.00,	1.00,	1.00,	0.57,	0.32,	0.21,	0.16,	0.15,	0.14,	0.15,	0.15,	0.14,	0.14,	0.14,	0.15,	0.15,	0.16,	0.16,	0.18,	0.26,	0.40,	0.59	],
"Artikeldetailseite":[	0.02,	0.03,	0.03,	0.03,	0.02,	0.02,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.02	],
"BBS":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.65,	0.59,	0.51,	0.53,	0.52,	0.49,	0.48,	0.47,	0.51,	0.49,	0.50,	0.52,	0.63,	1.00,	1.00,	1	],
"Checkout":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.83,	0.46,	0.32,	0.28,	0.24,	0.25,	0.24,	0.22,	0.22,	0.22,	0.23,	0.22,	0.23,	0.23,	0.27,	0.39,	0.65,	1	],
"Einstiegsseite":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.59,	0.39,	0.32,	0.33,	0.29,	0.29,	0.28,	0.25,	0.19,	0.18,	0.21,	0.23,	0.24,	0.25,	0.29,	0.40,	0.70,	1	],
"Errorseite404":[	0.38,	0.50,	0.54,	0.39,	0.35,	0.32,	0.33,	0.67,	0.49,	0.31,	0.32,	0.35,	0.36,	0.32,	0.37,	0.32,	0.31,	0.34,	0.35,	0.33,	0.32,	0.34,	0.33,	0.33	],
"Kundenbewertungsseite":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.61,	0.42,	0.34,	0.33,	0.29,	0.30,	0.29,	0.27,	0.27,	0.26,	0.27,	0.25,	0.25,	0.23,	0.24,	0.31,	0.48,	0.68	],
"Login":[	1.00,	1.00,	1.00,	1.00,	1.00,	0.67,	0.36,	0.21,	0.16,	0.15,	0.12,	0.15,	0.15,	0.14,	0.14,	0.13,	0.15,	0.15,	0.17,	0.17,	0.21,	0.32,	0.58,	0.84	],
"MYA_Dashboard":[	0.73,	1.00,	1.00,	1.00,	0.71,	0.42,	0.24,	0.17,	0.14,	0.14,	0.13,	0.14,	0.14,	0.13,	0.13,	0.12,	0.13,	0.13,	0.14,	0.14,	0.17,	0.23,	0.35,	0.5	],
"MYA_Invoices":[	1.00,	1.00,	1.00,	1.00,	1.00,	0.53,	0.30,	0.20,	0.16,	0.16,	0.15,	0.16,	0.17,	0.16,	0.16,	0.16,	0.16,	0.17,	0.18,	0.18,	0.21,	0.29,	0.45,	0.63	],
"MYA_Orders":[	0.74,	1.00,	1.00,	1.00,	0.75,	0.44,	0.24,	0.16,	0.13,	0.12,	0.11,	0.12,	0.12,	0.11,	0.11,	0.11,	0.12,	0.12,	0.12,	0.12,	0.15,	0.21,	0.34,	0.49	],
"MYA_UP":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.70,	0.55,	0.55,	0.64,	0.63,	0.65,	0.63,	0.68,	0.49,	0.52,	0.67,	0.67,	0.75,	0.79,	1.00,	1.00,	1.00,	1	],
"Payment-Selection-FD-ViewPaymentSelection":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.78,	0.79,	0.75,	0.69,	0.71,	0.72,	0.72,	0.71,	0.71,	0.69,	0.76,	1.00,	1.00,	1	],
"Paymentinfo":[	1.00,	1.00,	1.00,	1.00,	1.00,	0.76,	0.43,	0.27,	0.21,	0.20,	0.19,	0.21,	0.22,	0.21,	0.22,	0.21,	0.22,	0.22,	0.24,	0.25,	0.29,	0.40,	0.64,	1	],
"Produktliste":[	0.16,	0.21,	0.25,	0.19,	0.17,	0.13,	0.09,	0.07,	0.06,	0.06,	0.05,	0.05,	0.05,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.06,	0.10,	0.14	],
"Storefront":[	0.13,	0.16,	0.20,	0.18,	0.14,	0.10,	0.07,	0.05,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.04,	0.06,	0.09,	0.12	],
"Suchergebnisseite":[	0.08,	0.12,	0.16,	0.16,	0.11,	0.07,	0.04,	0.03,	0.02,	0.02,	0.02,	0.02,	0.02,	0.01,	0.01,	0.01,	0.02,	0.01,	0.01,	0.01,	0.02,	0.02,	0.04,	0.06	],
"Warenkorb":[	0.35,	0.57,	0.74,	0.74,	0.53,	0.30,	0.17,	0.11,	0.08,	0.07,	0.06,	0.06,	0.06,	0.06,	0.06,	0.06,	0.06,	0.06,	0.05,	0.06,	0.07,	0.10,	0.17,	0.26	],
"Wishlist":[	0.56,	1.00,	1.00,	1.00,	0.79,	0.46,	0.25,	0.16,	0.13,	0.12,	0.11,	0.11,	0.11,	0.10,	0.09,	0.09,	0.10,	0.10,	0.10,	0.10,	0.11,	0.16,	0.28,	0.43	],
};
/*                                 */

/**
 *
 *
 *
 */
const liveHttpRequest = {
  Errorseite404: 0.21,
  Login: 0.5,
  Registration: 0.15,
  Produktliste: 0.09,
  Storefront: 0.65,
  Suchergebnisseite: 0.07,
};

/**
 *
 *
 */
export const sampligRates: Record<"live" | "develop", SamplingEnvConfig> = {
  live: {
    [transactionTypes[0]]: pageLoadLive,
    [transactionTypes[1]]: liveHttpRequest,
  },
  develop: { [transactionTypes[0]]: {}, [transactionTypes[1]]: {} },
};

export const getSamplingRate = (
  type: TransactionType,
  pagecluster: string,
  now = new Date(),
  env = import.meta.env.VITE_OTTO_INSTALLATION_ENV,
): number => {
  const current = now.getUTCHours(); /*          */
  const rates = sampligRates[env];

  if (type === "page-load") {
    const { [pagecluster]: pcRates = [] } = rates[type];
    return pcRates[current] ?? 1;
  }

  return rates[type][pagecluster] ?? 1;
};
